import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import PuertaSesion from './ui/Sesion.jsx'
import './estilos.css'
import { tituloApp } from './marca.js'

// El título también sale de marca.js: un solo lugar para el nombre
document.title = tituloApp()

// PWA instalable (hoja de ruta, punto 2): el service worker cachea el cascarón
// para que la app instalada abra sin señal. SOLO en producción — en desarrollo
// un SW cacheando estorbaría a Vite y a cada recarga de trabajo.
//
// El registro va DIRECTO, sin esperar el evento `load`: la capa de datos usa
// `await` de nivel de módulo (el import dinámico de Firestore), así que este
// módulo termina de evaluar DESPUÉS de que `load` ya disparó — un listener
// puesto aquí no correría jamás. Se comprobó contra el build real.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // Sin SW la app funciona igual; solo pierde el arranque sin señal.
  })
}

// La compuerta de sesión envuelve TODO: nada de la plataforma se monta sin usuario
// con rol (salvo las exenciones de desarrollo — ver Sesion.jsx).
createRoot(document.getElementById('raiz')).render(
  <React.StrictMode>
    <PuertaSesion>
      <App />
    </PuertaSesion>
  </React.StrictMode>
)
